import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  margin: auto;
  justify-content: flex-start;
  gap: 1rem 3rem;
  margin-left: 3.5rem;
`;

export const cardStyle = {
  width: '20%',
  height: '4rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  border: `solid 1px `,
  borderRadius: '10px',
  borderColor: colors.GRAY_HR,
  marginBottom: '1rem,',
  padding: '0',
};

export const textStyle = {
  fontFamily: 'metropolis',
  color: colors.GRAY_DARK,
  margin: '0',
};

export const buttonStyle = {
  color: 'red',
  borderColor: 'red',
  marginLeft: '1rem',
  marginTop: '2rem',
  borderRadius: '10px',
};

export const iconStyle = { transform: 'scale(1.1)', minHeight: '30px' };

export default { CardContainer, cardStyle, buttonStyle, iconStyle };
